import { INVOICE_CONSTANTS, APPLICATION_CONSTANTS } from '../../AppConstants';
import {
	formatAmount, getXrequestId
} from '../../UtilityComponents/Util';
import SubComp from 'common/ReminderFrequency/ReminderFrequency';
const xreqId = getXrequestId();

export const searchInput = {
	value: '',
	label: '',
	info: 'Enter full Invoice Number/booking Id to search invoice list',
	placeholder: 'Invoice no. or Booking ID',
	type: 'text',
	textType: 'search'
};
export const textsConfig = {
	onBoarding: {
		reminder: {
			heading: 'Low Balance Reminders',
			text: 'Set the amount limit and number of days to receive reminders whenever your wallet balance becomes insufficient.'
		}
	},
	bundleSection: {
		heading: 'Download Related Invoices',
		text: 'Access monthly or quarterly folder of invoices based on your search requirements. Click on the folder to download all the related invoices in one go.'
	},
	filter: {
		heading: 'Invoice Filter',
		text: 'Apply filters to view only those invoices which suit your purpose.'
	},
	list: {
		heading: 'View & Download Invoices',
		text: 'View all the invoices based on your search requirements and download multiple invoices with an easy click option.'
	},
	help: {
		heading: 'Refer to Help Section',
		text: 'Revisit the benefits and onboarding process of Invoice from the Invoice section here.'
	},
	FILTER_QUERY_FAILED: `Try removing some filters to see more results ${xreqId ? ` (error:${xreqId})` : ''}`,
	INIT_QUERY_FAILED: `Try searching for different dates to see more results ${xreqId ? ` (error:${xreqId})` : ''}`,
	SEARCH_QUERY_FAILED: `Try different Booking ID/Invoice no. to see results ${xreqId ? ` (error:${xreqId})` : ''}`,
	REMINDER_SETTING: 'Mailer Settings',
	REMINDER_RADIO_TEXT: {
		activeTitle: 'Automailer Enabled - ',
		defaultTitle: 'Enable Automailer - '
	}
};
export const dateConfig = {

};

export const WEEK_DAYS = {
	'7': 'Sundays',
	'1': 'Monday',
	'2': 'Tuesday',
	'3': 'Wednesday',
	'4': 'Thursday',
	'5': 'Friday',
	'6': 'Saturday'
};
export const InvoiceAirlines = [
	'6E', 'SG', 'UK', 'G8'
];
export const filters = {
	initCount: {},
	gstn: {
		label: 'GSTIN',
		type: INVOICE_CONSTANTS.DROPDOWN,
		key: INVOICE_CONSTANTS.GST_FILTER,
		filterKey: 'gstn',
		isMulti: true,
		hideSelOptions: false,
		value: '',
		trackVal: 'GSTIN',
		options: [],
		selectedCount: 0
	},
	tripTags: {
		isGrouped: true,
		label: 'Trip Tags',
		type: INVOICE_CONSTANTS.DROPDOWN,
		key: INVOICE_CONSTANTS.TRIP_TAG_FILTER,
		isMulti: true,
		hideSelOptions: false,
		value: [],
		options: [],
		trackVal: 'triptag',
		selectedCount: 0
	},
	dateRange: {
		label: 'Booking Date Range',
		type: INVOICE_CONSTANTS.CHECKBOX,
		startkey: 'startDate',
		showClear: false,
		endKey: 'endDate',
		key: INVOICE_CONSTANTS.DATE_FILTER,
		value: '',
		selectedCount: 0,
		appliedFilterKey: 'BDR : ',
		options: [
			{
				label: 'Enter Dates',
				type: INVOICE_CONSTANTS.CUSTOM_DATE_FILTER,
				value: '',
				trackVal: 'date_custom',
				checked: false,
				key: INVOICE_CONSTANTS.DATE_FILTER,
				filterKey: 'dateRange',
				disabledDays: {
					before: INVOICE_CONSTANTS.DISABLE_CALENDER_BEFORE,
					after: APPLICATION_CONSTANTS.TODAY
				},
				appliedFilterKey: 'IDR : ',
				headText: 'Last Quarter'

			}
		]
	},
	invoiceDateRange: {
		label: 'MMT Invoice Date Range',
		type: INVOICE_CONSTANTS.CHECKBOX,
		startkey: INVOICE_CONSTANTS.INVOICE_START_DATE,
		showClear: false,
		endKey: INVOICE_CONSTANTS.INVOICE_END_DATE,
		key: INVOICE_CONSTANTS.INVOICE_DATE_FILTER,
		value: '',
		selectedCount: 0,
		appliedFilterKey: 'IDR : ',
		options: [
			{
				label: 'Enter Dates',
				type: INVOICE_CONSTANTS.CUSTOM_DATE_FILTER,
				value: '',
				trackVal: 'date_custom',
				checked: false,
				key: INVOICE_CONSTANTS.INVOICE_DATE_FILTER,
				filterKey: INVOICE_CONSTANTS.INVOICE_DATE_FILTER,
				disabledDays: {
					before: INVOICE_CONSTANTS.DISABLE_CALENDER_BEFORE,
					after: APPLICATION_CONSTANTS.TODAY
				},
				appliedFilterKey: 'IDR : '
			}

		]
	},
	invoiceType: {
		label: 'Invoice Type',
		type: INVOICE_CONSTANTS.CHECKBOX,
		value: '',
		showClear: false,
		key: INVOICE_CONSTANTS.INVOICE_FILTER,
		selectedCount: 0,
		options: [{
			type: 'select',
			isMulti: true,
			value: 'mmt',
			[INVOICE_CONSTANTS.INVOICE_VALUE]: [],
			isGrouped: true,
			key: INVOICE_CONSTANTS.INVOICE_FILTER,
			label: 'MakeMyTrip Invoice',
			checked: false,
			filterKey: INVOICE_CONSTANTS.INVOICE_FILTER,
			count: '',
			trackVal: 'invoiceType_mmt',
			index: 0,
			options: [],
			hideSelOptions: false
		},
		{
			type: 'select',
			isMulti: true,
			value: 'gst',
			[INVOICE_CONSTANTS.INVOICE_VALUE]: [],
			isGrouped: true,
			key: INVOICE_CONSTANTS.INVOICE_FILTER,
			filterKey: INVOICE_CONSTANTS.INVOICE_FILTER,
			label: 'Vendor (GST) Invoice',
			options: [],
			checked: false,
			hideSelOptions: false,
			count: '',
			trackVal: 'invoiceType_vendor',
			index: 1
		}

		]
	},
	orderType: {
		label: 'Trip Type',
		type: INVOICE_CONSTANTS.CHECKBOX,
		value: '',
		key: 'lob',
		showClear: false,
		selectedCount: 0,
		options: [{
			value: 'FLIGHT',
			label: 'Flights',
			count: '',
			filterKey: 'orderType',
			index: 0,
			trackVal: 'triptype_flight'
		},
		{
			value: 'HOTEL',
			label: 'Hotels',
			count: '',
			filterKey: 'orderType',
			trackVal: 'triptype_hotel',
			index: 1
		},
		{
			value: 'CAB',
			label: 'Cabs',
			count: '',
			trackVal: 'triptype_cab',
			filterKey: 'orderType',
			index: 2
		},
		{
			value: 'BUS',
			label: 'Bus',
			count: '',
			trackVal: 'triptype_bus',
			filterKey: 'orderType',
			index: 3
		}, {
			value: 'TRAIN',
			label: 'Trains',
			count: '',
			trackVal: 'triptype_train',
			filterKey: 'orderType',
			index: 4
		}

		]
	},
	invoiceStatus: {
		type: INVOICE_CONSTANTS.CHECKBOX,
		value: '',
		label: 'Invoice Status',
		key: 'invoiceStatus',
		showClear: false,
		selectedCount: 0,
		options: [{
			value: 'NEW',
			label: 'New',
			count: '',
			filterKey: 'invoiceStatus',
			trackVal: 'invoiceStatus_new',
			index: 0
		},
		{
			value: 'DOWNLOADED',
			label: 'Downloaded',
			filterKey: 'invoiceStatus',
			count: '',
			trackVal: 'invoiceStatus_downloaded',
			index: 1
		}

		]
	},
	paymentMethod: {
		label: 'Payment Method',
		type: INVOICE_CONSTANTS.CHECKBOX,
		value: '',
		showClear: false,
		key: 'paymentMethods',
		selectedCount: 0,
		options: [{
			value: 'WALLET',
			label: 'myBiz Wallet',
			filterKey: 'paymentMethod',
			trackVal: 'payment_wallet',
			count: '',
			index: 0
		},
		{
			value: 'OTHERS',
			label: 'Other (Credit/Debit Card,Net banking etc.)',
			filterKey: 'paymentMethod',
			trackVal: 'payment_others',
			count: '',
			index: 1
		}

		]
	},
	others: {
		label: 'Business Essentials',
		type: INVOICE_CONSTANTS.CHECKBOX,
		value: '',
		showClear: false,
		key: 'others',
		selectedCount: 0,
		options: [{
			value: 'MYBIZ_ASSURED',
			label: 'myBizAssured',
			filterKey: 'others',
			trackVal: 'mybiz_assured',
			count: '',
			index: 0
		}]
	}
};

export const listHeader = {
	list: [{
		text: 'Booking ID'
	},
	{
		text: 'ISSUER'
	},
	{
		text: 'INVOICES'
	}, {
		text: 'BOOKED ON',
		isSort: true,
		trackVal: 'BookingDate',
		key: INVOICE_CONSTANTS.BOOK_SORT
	}, {
		text: 'TRAVEL ON'
	}, {
		text: 'COMPANY GSTIN'
	}
	]
};

export const bundleObject = {
	monthData: {},
	filterMonths: [],
	totalCounts: {
		[INVOICE_CONSTANTS.MMT_TYPE]: 0,
		[INVOICE_CONSTANTS.GST_TYPE]: 0,
		new: 0,
		total: 0,
		mmtDownloaded: 0,
		gstDownloaded: 0,
		lastUpdate: 0
	},
	[INVOICE_CONSTANTS.CUSTOM_DATE_FILTER]: {
		bundleCount: 0,
		count: 0,
		bundleData: {}
	}
};

export const bundleData = {
	count: 0,
	bundleCount: 0,
	bundleData: {}
};

export const pageLinks = [{ href: '#', text: 'What is this?' }, { href: '#', text: 'Help' }];

const WeeksCount = [
	{ value: '1', label: '1' },
	{ value: '2', label: '2' },
	{ value: '3', label: '3' },
	{ value: '4', label: '4' }
];

const Months = [
	{ value: '1', label: '1' },
	{ value: '2', label: '2' },
	{ value: '3', label: '3' },
	{ value: '4', label: '4' },
	{ value: '5', label: '5' },
	{ value: '6', label: '6' },
	{ value: '7', label: '7' },
	{ value: '8', label: '8' },
	{ value: '9', label: '9' },
	{ value: '10', label: '10' },
	{ value: '11', label: '11' }
];

const Days = [{
	'value': '1',
	'label': '1'
}, {
	'value': '2',
	'label': '2'
}, {
	'value': '3',
	'label': '3'
}, {
	'value': '4',
	'label': '4'
}, {
	'value': '5',
	'label': '5'
}, {
	'value': '6',
	'label': '6'
}, {
	'value': '7',
	'label': '7'
}, {
	'value': '8',
	'label': '8'
}, {
	'value': '9',
	'label': '9'
}, {
	'value': '10',
	'label': '10'
}, {
	'value': '11',
	'label': '11'
}, {
	'value': '12',
	'label': '12'
}, {
	'value': '13',
	'label': '13'
}, {
	'value': '14',
	'label': '14'
}, {
	'value': '15',
	'label': '15'
}, {
	'value': '16',
	'label': '16'
}, {
	'value': '17',
	'label': '17'
}, {
	'value': '18',
	'label': '18'
}, {
	'value': '19',
	'label': '19'
}, {
	'value': '20',
	'label': '20'
}, {
	'value': '21',
	'label': '21'
}, {
	'value': '22',
	'label': '22'
}, {
	'value': '23',
	'label': '23'
}, {
	'value': '24',
	'label': '24'
}, {
	'value': '25',
	'label': '25'
}, {
	'value': '26',
	'label': '26'
}, {
	'value': '27',
	'label': '27'
}, {
	'value': '28',
	'label': '28'
}, {
	'value': '29',
	'label': '29'
}, {
	'value': '30',
	'label': '30'
}, {
	'value': '31',
	'label': '31'
}];

export const WeekDayfield = {
	isMulti: false,
	isOpenTop: false,
	value: '',
	name: 'every_period',
	subtitle: 'How frequently do you want to be notified?',
	fieldLabel: 'Frequency',
	key: 'every_period',
	type: 'select',
	trackVal: 'reminder_settings_frequency',
	validation: {
		required: {
			msg: 'Required!'
		}
	},
	options: WeeksCount
};

export const MonthField = {
	isMulti: false,
	isOpenTop: false,
	value: '',
	name: 'every_period',
	subtitle: 'How frequently do you want to be notified?',
	fieldLabel: 'Frequency',
	key: 'every_period',
	type: 'select',
	trackVal: 'reminder_settings_frequency',
	validation: {
		required: {
			msg: 'Required!'
		}
	},
	options: Months
};

export const DayField = {
	isMulti: false,
	isOpenTop: false,
	value: '',
	name: 'on_day',
	subtitle: 'How frequently do you want to be notified?',
	fieldLabel: 'on_day',
	key: 'on_day',
	type: 'select',
	trackVal: 'on_day',
	validation: {
		required: {
			msg: 'Required!'
		}
	},
	options: Days
};

export const DailyField = {
	isMulti: false,
	isOpenTop: false,
	value: '',
	name: 'every_period',
	subtitle: 'How frequently do you want to be notified?',
	fieldLabel: 'every_period',
	key: 'every_period',
	type: 'select',
	trackVal: 'every_period',
	validation: {
		required: {
			msg: 'Required!'
		}
	},
	options: Days
};

export const WeekField = {
	isMulti: false,
	isOpenTop: false,
	value: '',
	name: 'on_day',
	subtitle: 'How frequently do you want to be notified?',
	fieldLabel: 'on_day',
	key: 'on_day',
	type: 'radio',
	trackVal: 'on_day',
	validation: {
		required: {
			msg: 'Required!'
		}
	},
	customClass: 'weekDays',
	options: [
		{ label: 'M', value: '1' },
		{ label: 'T', value: '2' },
		{ label: 'W', value: '3' },
		{ label: 'T', value: '4' },
		{ label: 'F', value: '5' },
		{ label: 'S', value: '6' },
		{ label: 'S', value: '7' }

	]
};

export const reminderModalDtls = {
	title: 'Mailer Settings',
	desc: 'You will be sent an Email with the invoices download link based on the settings you define below',
	details: [{
		isMulti: false,
		value: '',
		name: 'frequency',
		subtitle: 'How frequently do you want to receive invoices on E-Mails?',
		fieldLabel: 'Frequency',
		key: 'frequency',
		type: 'select',
		classPrefix: 'frequency custom-styles-select',
		formatVal: formatAmount,
		trackVal: 'reminder_settings_frequency',
		validation: {
			required: {
				msg: 'Required!'
			}
		},
		subComponent: SubComp,
		subValues: {},
		subField: {},
		options: [
			{ value: 'WEEKLY', label: 'Weekly' },
			{ value: 'MONTHLY', label: 'Monthly' },
			{ value: 'DAILY', label: 'Daily' }
		],
		errorOnBlur: true,
		isOpenTop: false,
		isMandatory: true
	}
	],
	cta: {
		text: 'Save & enable Mailer',
		type: 'Primary'
	}
};

export const VIEW_ALL = 'View All Folders';
export const VIEW_LESS = 'View Less';

export const HELP_TEXT = {
	how: 'How to use Invoice Section?'
};
